import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[stxtMediaPreviewClose]',
  standalone: true
})
export class MediaPreviewCloseDirective {
  @Input() overlayClasses: string[] = [
    'media_overlay',
    'media_lightbox__carousel',
    'media_preview__carousel',
    'picsum-img-wrapper',
    'media_lightbox__body',
    'media_preview__body'
  ];
  @Output() overlayClick: EventEmitter<void> = new EventEmitter<void>();

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    const target = event.target as HTMLElement;

    if (this.overlayClasses.some(className => target.classList.contains(className))) {
      this.overlayClick.emit();
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.overlayClick.emit();
    }
  }
}
